import { cn } from "@/lib/utils";
import { ImageBody } from "../api/templates";
import { Button } from "@/shared/ui/button.tsx";
import { Check } from "lucide-react";


type Props = {
  galleryImages: ImageBody[],
  onSelect: (image: { image_id: number, image_url: string }) => void,
  selected: { image_id: number, image_url: string } | undefined
  hasNextPage: boolean,
  fetchNextPage: () => void,
}

const ImageGrid = ({ galleryImages, onSelect, fetchNextPage, hasNextPage, selected }: Props) => {

  return (
    <div className="size-full overflow-auto pt-0 no-scrollbar ">
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
        {galleryImages.map((image, index) => (
          <div
            key={index}
            className={cn(
              "relative aspect-square overflow-hidden bg-white rounded-xl cursor-pointer transition-all",
              "border",
              selected?.image_id === image.id
                ? "border-primary ring-2 ring-primary ring-offset-2 ring-offset-background"
                : "border-gray-800 hover:border-gray-600",
            )}
          >
            <img
              src={image.image_url || "/placeholder.svg"}
              alt={image.prompt}
              className={cn("object-cover transition-all hover:scale-110 duration-700 w-full aspect-square", selected?.image_id === image.id ? "opacity-90" : "opacity-100")}
            />

            <Button
              size="icon"
              variant="outline"
              onClick={(e) => {
                e.stopPropagation()
                onSelect({ image_id: image.id, image_url: image.image_url })
              }}
              className={cn("rounded-full border border-purple-400 transition-all ease-in-out animate-wave p-2 absolute top-2 right-2 z-50",

              selected?.image_id === image.id
                ? "bg-purple-400 hover:bg-purple-500"
                : "border-gray-800 hover:border-gray-600",
              )}>
              <Check className="h-6 w-6 text-black" />
            </Button>
          </div>
        ))}
      </div>
      <div className="w-full py-6 flex items-center justify-center">
        {hasNextPage &&
          <Button
            variant="outline"
            className="rounded-full border border-purple-600"
            onClick={() => fetchNextPage()}
          >View More
          </Button>
        }
      </div>
    </div>
  )
}

export default ImageGrid;
